export const NAZK_TITLE = "napc";
export const NAZK_DOCUMENT_TYPE = "register";
